import React, { FunctionComponent } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

import { Tree } from 'antd'
import { TreeProps } from 'antd/lib/tree'

import './style.css'

interface CustomTreeProps extends TreeProps {
	onCheck?: (checked: any) => void
}

const CustomTree: FunctionComponent<CustomTreeProps> = (props) => {
	const { treeData, checkedKeys, defaultCheckedKeys, onCheck, disabled } = props
	return (
		<Tree
			checkable
			multiple
			blockNode
			switcherIcon={<FontAwesomeIcon icon={faChevronDown} color="#434343" fontWeight="900" opacity="0.5" />}
			className="filter"
			onCheck={onCheck}
			checkedKeys={checkedKeys}
			defaultCheckedKeys={defaultCheckedKeys}
			treeData={treeData}
			selectable={false}
			disabled={disabled}
		/>
	)
}

export default CustomTree
